import { getListTypeEntriesByExternalReferenceCode } from "../services/course";
import { useEffect, useState } from "react";

const useFetchExpertiseLevel = () => {
  const [expertiseLevels, setExpertiseLevels] = useState([]);

  useEffect(() => {
    const fetchExpertiseLevelsData = async () => {
      try {
        const response = await getListTypeEntriesByExternalReferenceCode("P2S3_EXPERTISE_LEVELS");

        if (response && Array.isArray(response.items)) {
          setExpertiseLevels(response.items);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchExpertiseLevelsData();
  }, [setExpertiseLevels]);

  return (
    {expertiseLevels}
  )
}

export default useFetchExpertiseLevel;